<section class="card upsi-bulk-card">
    <div class="card-header upsi-bulk-card-header d-flex flex-wrap align-items-center justify-content-between">
      <span class="cat__core__title mb-0">
        <strong>UPSI Bulk Uploaded List</strong>
      </span>
      <div class="upsi-bulk-header-actions">
        <button type="button" class="btn btn-sm btn-primary" data-toggle="modal"
          [appHasPermission]="{'Url': '/upsiBulkData/all/add', 'method':'post', 'menu': 'UPSI Detail All'}"
          data-target="#CsvUpload">
          EXCEL File Upload
        </button>
      </div>
    </div>
    <!-- <section class="card search-box">
      <div class="card-header" data-toggle="collapse" data-target="#search-div">Modify Search <span class="pull-right"><i
            class="fa fa-filter" aria-hidden="true"></i></span> </div>
      <div class="card-block collapse" id="search-div">
        <div class="row">
          <div class="col-lg-12">
  
            <div class="row">
              <div class="col-sm-2">
                <label>Name :</label>
  
                <div class="input-group">
                  <input [(ngModel)]="sharerName" [ngModelOptions]="{standalone: true}">
  
                </div>
              </div>
  
              <div class="col-sm-4">
                <label>Created Date Range:</label>
  
                <div class="input-group" (click)="$event.stopPropagation()">
  
                  From:&nbsp;
                  <input class="form-control" [(ngModel)]="SearchDateFrom" style="padding:6px;z-index: 0;"
                    placeholder="dd-mm-yyyy" ngbDatepicker #c="ngbDatepicker" (focus)="c.toggle();r.close();"
                    (document:click)="c.close();" [ngModelOptions]="{standalone: true}">
                  <button class="input-group-addon" (click)="c.toggle();r.close();" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button> &nbsp;&nbsp; To:&nbsp;
                  <input class="form-control" [(ngModel)]="SearchDateTo" style="padding:6px;z-index: 0;"
                    placeholder="dd-mm-yyyy" ngbDatepicker #r="ngbDatepicker" (focus)="r.toggle();c.close();"
                    (document:click)="r.close();" [ngModelOptions]="{standalone: true}">
                  <button class="input-group-addon" (click)="r.toggle();c.close();" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
  
              </div>
              <div class="col-sm-2">
                <label>&nbsp;&nbsp;&nbsp;</label>
                <div class="input-group">
  
                  <button type="button" class="btn btn-sm btn-primary mb-2" (click)="searchData();">
                    <i class="fa fa-search"></i>Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" class="btn btn-sm btn-default mb-2" (click)="clear()">
                    <i class="fa fa-refresh"></i>Clear</button>
                </div>
              </div>
  
            </div>
  
          </div>
        </div>
      </div>
    </section> -->
  
    <div class="card-block datatable-card-block upsi-bulk-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="datatabletool bulk-toolbar-actions">
            <button type="button" class="btn btn-sm btn-primary" [disabled]="selectedItems.length === 0 || erronousSelectedItemsForWhichSaveBeDisbaled.length > 0"
              data-toggle="modal" data-target="#uploadProofDialog" (click)="addSelectedUpsiDetails()">
              <i class="fa fa-save"></i>&nbsp; Save
            </button>
            <button type="button" class="btn btn-sm btn-danger" [disabled]="selectedItems.length === 0"
              data-toggle="modal" data-target="#uploadProofDialog" (click)="deleteSelectedUpsiDetails()">
              <i class="fas fa-trash"></i>&nbsp; Delete
            </button>
            <button type="button" class="btn btn-sm btn-danger" (click)="selectUnselectAllInvalidUPSI()">
              <i class="fa fa-filter"></i>&nbsp; Select All Invalid Entries
            </button>
          </div>
          <div class="margin-bottom-50">
            <div class="table-responsive upsi-bulk-table-wrap">
              <table id="bulk-table" datatable [dtOptions]="dtUpsiData" [dtTrigger]="dtUpsiDataTrigger"
                class="table table-hover compact cell-border stripe upsi-bulk-datatable" style="cursor: pointer; width: 100%;">
                <thead>
                  <tr>
                    <th>
                      <div class="md-checkbox">
                        <input type="checkbox" (change)="selectUnselectAllUPSI($event)" [(ngModel)]="selectedAll"
                          name="internalUser" id="selectedUserAll">
                        <label for="selectedUserAll">&nbsp;</label>
                      </div>
                    </th>
                    <th style="width: 100px">Error</th>
                    <th style="width: 100px">Sharer Name</th>
                    <th style="width: 100px">Sharer Email ID</th>
                    <th style="width: 100px">Recipents Name</th>
                    <th style="width: 100px">Recipents Email ID</th>
                    <th style="width: 100px">Nature of UPSI</th>
                    <th style="width: 100px">Brief details of UPSI shared</th>
                    <th style="width: 100px">Purpose for Sharing</th>
                    <th style="width: 100px">Manner mode of sharing</th>
                    <th style="width: 100px">Shared Date</th>
                    <th style="width: 100px">Shared Time</th>
                    <th style="width: 100px">Date of initiation of UPSI</th>
                    <th style="width: 100px">Persons in possession of UPSI</th>
                    <th style="width: 100px">Date</th>
                    <th style="width: 100px">Time</th>  
                    <th style="width: 100px" class="bulk-col-action">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of UPSIBulkData; let count=index" style="line-height: 25px;">
                    <td>
                      <div class="md-checkbox">
                        <input id="selectedUPSIUser{{count + 1 }}" 
                          [checked]="selectedItems.includes(data._id)" type="checkbox" name="internalUser"
                          (change)="selectUnselectUpsi($event, data)">
                        <label for="selectedUPSIUser{{count + 1}}">&nbsp;</label>
                      </div>
                    </td>
                    <td tabindex="1">
                      <button type="button" class="btn-sm btn btn-danger" [disabled]="!hasError(data)"
                        (click)="showErrorDialog(data._id)">
                        <span class="fa fa-warning"></span>
                      </button>&nbsp;&nbsp;&nbsp;
                    </td>
                    <td tabindex="1">{{data.SharerId ? data.SharerId.Name : ""}}</td>
                    <td tabindex="1">{{maskEmail(data.SharerId ? data.SharerId.email_id : "")}}</td>
                    <td tabindex="1" class="upsi-bulk-recipient-cell">
                      <div class="upsi-bulk-recipient-scroll">
                      <ul class="list-unstyled mb-0 pl-0">
                      <li *ngFor="let Recipient of data.Recipients">
                        <span>{{Recipient.Name}}</span>
                      </li>
                      </ul>
                      </div>
                    </td>
                    <td tabindex="1" class="upsi-bulk-recipient-cell">
                      <div class="upsi-bulk-recipient-scroll">
                      <ul class="list-unstyled mb-0 pl-0">
                      <li *ngFor="let Recipient of data.Recipients">
                        <span>{{ maskEmail(Recipient.email_id) }}</span>
                      </li>
                      </ul>
                      </div>
                    </td>
                    <td tabindex="1">{{data.NatureofUPSI ? data.NatureofUPSI.Item : ""}}</td>
                    <td tabindex="1">{{data.TypeOfShared}}</td>
                    <td tabindex="1">{{data.purposeForSharing}}</td>
                    <td tabindex="1">{{data.modeOfSharing}}</td>
                    <td tabindex="1">{{ data.SharedDate ? (data.SharedDate | date : 'dd-MM-y') : '' }}</td>
                    <td tabindex="1">{{data.SharedTime}}</td>
                    <td tabindex="1">{{ data.DateOfInitiation ? (data.DateOfInitiation | date : 'dd-MM-y') : '' }}</td>
                    <td tabindex="1">{{data.possessionOfUPSI}}</td>
                    <td tabindex="1">{{ data.PublicDate ? (data.PublicDate | date : 'dd-MM-y') : '' }}</td>
                    <td tabindex="1">{{data.PublicTime}}</td>
                    
                    <td class="bulk-col-action">
                      <div class="bulk-action-btns d-flex flex-wrap align-items-center">
                      <button *ngIf="globals.upsiAdmin" type="button" class="btn-sm btn btn-success" [disabled]="hasError(data)"
                      [appHasPermission]="{'Url': '/upsiAdmin/all/add', 'method':'post', 'menu': 'UPSI Detail All'}"
                        (click)="addUpsiDetails(data._id)">
                        <span class="fa fa-save"></span>
                      </button>
                      <button *ngIf="!globals.upsiAdmin" type="button" class="btn-sm btn btn-success" [disabled]="hasError(data)"
                      [appHasPermission]="{'Url': '/upsiAdmin/individual/add?goveva=true&email=', 'method':'post', 'menu': 'UPSI Detail Individual'}"
                        (click)="addUpsiDetails(data._id)">
                        <span class="fa fa-save"></span>
                      </button>
                      <button type="button" class="btn-sm btn btn-warning"
                        [appHasPermission]="{'Url': '/upsiBulkData/all/edit', 'method':'post', 'menu': 'UPSI Bulk Upload'}"
                        (click)="editUpsiDetails(data._id)">
                        <span class="fa fa-pencil"></span>
                      </button>&nbsp;&nbsp;&nbsp;
                      <button type="button" class="btn-sm btn btn-danger"
                        [appHasPermission]="{'Url': '/upsiBulkData/all/delete', 'method':'get', 'menu': 'UPSI Bulk Upload'}"
                        (click)="deleteConfirmation(data._id)">
                        <span class="fas fa-trash"></span>
                      </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  
    <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
      aria-labelledby="" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabelForDelete">
              <i class="fa fa-question-circle-o mr-2"></i>Confirm
            </h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                Are you sure you want to delete the Document?
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-danger" (click)="deleteRecord(documentManagementId)">
              <i class="fa fa-check"></i> &nbsp;Yes</button>
            <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
              <i class="fa fa-times"></i>&nbsp; No</button>
  
          </div>
        </div>
      </div>
    </div>
  
    <div class="modal" id="CsvUpload" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
      aria-labelledby="" aria-hidden="true" style="top: 50px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Upload Excel File</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <i class="fa fa-times"></i>
            </button>
  
          </div>
          <div class="modal-body">
            <div class="row">
  
              <div class="col-sm-12">
                <div class="input-group" style="margin-left: 5px;" title="Download Format File">
                  <button (click)="generateExcelFile()" class="btn btn-sm btn-primary">Download Format File
                    <span class="fa fa-download"></span>
                  </button>
                </div>
              </div>
  
  
            </div>
            <br>
            <div class="row">
  
  
              <div class="col-sm-12">
                <input type="file" id="fileInput" accept=".xlsx" class='form-control' (change)="fileChanged($event)">
                <span style="color: red" *ngIf="fileSizeError">File size is greater than 2MB</span>
                <span style="color: red" *ngIf="fileExtensionError">Please upload excel file only.</span>
  
              </div>
            </div>
          </div>
          <div class="modal-footer">
  
            <button type="button" (click)="upload()" [disabled]="isUploadNotValid" class="btn btn-sm btn-primary"
              data-dismiss="modal">
              Upload</button>
            <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
              <i class="fa fa-times"></i>&nbsp;Cancel</button>
          </div>
        </div>
      </div>
    </div>
  
    <div class="modal" id="ErrorDialog" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
      aria-labelledby="" aria-hidden="true" style="top: 50px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Errors
            </h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <i class="fa fa-times"></i>
            </button>
  
          </div>
          <div class="modal-body">
            <h5>Please clear below errors</h5>
            <ul *ngFor="let key of arrOfKeys(errorLogs)">
              <li *ngFor="let item of errorLogs[key]">
                <div style="list-style: none;">Field Name : {{item.fieldName}}</div>
                <div *ngIf="item.fieldValue !== ''" style="list-style: none;">Field Value : {{item.fieldValue}}</div>
                <div style="list-style: none;">Error Message : {{item.message}}</div>
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
              <i class="fa fa-times"></i>&nbsp;Cancel</button>
          </div>
        </div>
      </div>
    </div>
  
  
    <app-alert></app-alert>
  </section>